import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { getOnlinePreviewUrl as x } from "@oppein/op-utils";
import { defineComponent as N, openBlock as u, createElementBlock as m, createElementVNode as v, createVNode as s, withCtx as i, createCommentVNode as k, Fragment as P } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as l, unref as f } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { useMessage as U } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import E from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/card/src/Card.js";
import { normalizeStyle as V } from "../../node_modules/.pnpm/@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
import z from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
import B from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
const L = { class: "tw:bg-gray-100 tw:min-h-[400px]" }, F = ["src", "height"], D = /* @__PURE__ */ N({
  name: "FilePreviewContent",
  __name: "filePreview.ce",
  setup(I, { expose: w }) {
    const c = l(null), d = U(), r = l(!1), t = l(!1), a = l(""), n = l("80%"), p = l("600px"), h = (e) => {
      t.value = !0;
      try {
        const o = x(e);
        console.log("previewUrl", o), a.value = o;
      } catch (o) {
        console.error(o), d.error("获取预览地址失败"), r.value = !1;
      } finally {
        t.value = !1;
      }
    }, _ = () => {
      t.value = !1;
    }, g = () => {
      t.value = !1, d.error("文件加载失败，请检查文件是否可访问"), r.value = !1;
    }, y = () => {
      r.value = !1, a.value = "";
    }, b = (e) => {
      e.fileUrl && h(e.fileUrl), r.value = !0;
    };
    if (typeof window != "undefined") {
      const e = () => {
        window.innerWidth <= 768 ? n.value = "95%" : n.value = "80%";
      };
      e(), window.addEventListener("resize", e);
    }
    return w({ open: b }), (e, o) => (u(), m(P, null, [
      v("div", {
        ref_key: "filePreviewContainer",
        ref: c
      }, null, 512),
      s(f(B), {
        show: r.value,
        "onUpdate:show": o[0] || (o[0] = (C) => r.value = C),
        "mask-closable": !1,
        to: c.value || "body"
      }, {
        default: i(() => [
          s(f(E), {
            title: "文件预览",
            style: V({ width: n.value }),
            bordered: !1,
            role: "dialog",
            closable: "",
            "on-close": y
          }, {
            default: i(() => [
              s(f(z), { show: t.value }, {
                default: i(() => [
                  v("div", L, [
                    a.value ? (u(), m("iframe", {
                      key: 0,
                      src: a.value,
                      frameborder: "0",
                      width: "100%",
                      height: p.value,
                      allow: "local-network-access",
                      class: "tw:bg-white tw:shadow-[0_0_10px_rgba(0,0,0,0.1)]",
                      onLoad: _,
                      onError: g
                    }, null, 40, F)) : k("", !0)
                  ])
                ]),
                _: 1
              }, 8, ["show"])
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      }, 8, ["show", "to"])
    ], 64));
  }
});
export {
  D as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/file-preview/filePreview.ce.vue.js
// module id = 869
// module chunks = 67